import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import {TagList} from '@/components/tags-manager-dialog'
import {SectionCard} from '@/components/section-card'
import {useTags} from '@/hooks/empresa/organizacion/use-tags'
import {SedeDetailDialog} from '@/components/perfil/sede-detail-dialog'

/** registro-entrevista-spec §3: a sede is a company fact, not an employee tag. */
export function SedesSection({businessId, canEdit}: {businessId: string; canEdit: boolean}) {
  const {t} = useTranslation()
  const {data} = useTags(businessId, 'sedes')
  const [creating, setCreating] = useState(false)
  const [editingId, setEditingId] = useState<string | null>(null)
  const sedes = data?.items ?? []

  return (
    <SectionCard
      testId="perfil-sedes-section"
      title={t('business.sedes.title')}
      bodyClassName="space-y-4 p-5"
      actions={
        canEdit ? (
          <Button size="sm" data-testid="sede-create-cta" onClick={() => setCreating(true)}>
            {t('business.sedes.create')}
          </Button>
        ) : undefined
      }>
      {sedes.length > 0 && (
        <div className="flex flex-wrap gap-2" data-testid="sede-detail-links">
          {sedes.map((sede) => (
            <Button
              key={sede.id}
              type="button"
              size="sm"
              variant="outline"
              data-testid={`sede-detail-open-${sede.id}`}
              onClick={() => setEditingId(sede.id)}>
              {sede.name}
              {' · '}
              {canEdit ? t('business.sedes.editTitle') : t('business.sedes.viewDetail')}
            </Button>
          ))}
        </div>
      )}

      <TagList businessId={businessId} kind="sedes" open canEdit={canEdit} />

      {canEdit && <SedeDetailDialog businessId={businessId} sedeId={null} open={creating} onOpenChange={setCreating} />}
      <SedeDetailDialog
        businessId={businessId}
        sedeId={editingId}
        open={editingId !== null}
        onOpenChange={(open) => !open && setEditingId(null)}
      />
    </SectionCard>
  )
}
